import { render, staticRenderFns } from "./foundpass.vue?vue&type=template&id=216ff5ee&scoped=true"
import script from "./foundpass.vue?vue&type=script&lang=js"
export * from "./foundpass.vue?vue&type=script&lang=js"
import style0 from "./foundpass.vue?vue&type=style&index=0&id=216ff5ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216ff5ee",
  null
  
)

export default component.exports